<template>
    <div>
        <v-btn small color="success" label="" @click="OpenDialog">
            {{TranslateText("license")}}
            <v-icon color="orange">access_time</v-icon>
        </v-btn>
        <span>
            <b>{{expireString}}</b>
        </span>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <!-- <v-card-title>
                    <span class="headline">License details</span>
                </v-card-title> -->
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6 md4 lg12>
                                <div class="display-2">{{expireString}}</div>
                            </v-flex>

                            <v-flex xs12 sm6 md4 lg12>
                                <div class="subheading">{{TranslateText('Key:')}} {{currentLicenseKey}}</div>
                            </v-flex>

                            <v-flex xs12 sm6 md4 lg12>
                                <div class="subheading">{{TranslateText('Client Code:')}} {{clientKey}}</div>
                            </v-flex>

                            <v-flex xs12 sm6 md4 lg12 mt-5>
                                <v-text-field v-model="newKey" :placeholder="TranslateText('Enter new license key here')" :label="TranslateText('License Key')">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" flat @click="dialog = false">Save</v-btn>
                    <v-btn color="grey" flat @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Licensing from '@/libs/licensing/licensing-base.js';
    export default {
        data: () => ({
            dialog: false,
            expireString: "Expires in 275 days.",
            timeInDays: 275,
            licenseValid: true,
            currentLicenseKey: '376E2F24-BAB5-412A-93C1-1D4290A3A451',
            clientKey: 'SOME MAC AND PRODUCT KEY',
            newKey: ''
        }),
        mounted() {
            let self = this;

            let licensingObj = new Licensing();
            licensingObj.GenerateClientKeyFromUserID(1)
            .then(clientKey => {
                self.clientKey = clientKey;
            })
            .catch(error => {

            })
        },
        methods: {
            OpenDialog() {
                let self = this;
                self.dialog = !self.dialog;
            },
            RedeemNewLicense() {
                let self = this;
                self.dialog = false
                alert('redeemed new license! TODO : ADD CODE HERE TO CALL LIB')
            }
        }
    }
</script>

<style>

</style>